// extracted by mini-css-extract-plugin
export default {"image":"BannerCard_image__3LZ2S","title":"BannerCard_title__2oRJ5","wrapper":"BannerCard_wrapper__XIR9-"};